// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#minorsForm[data-v-491483a6]{gap:30px}.is-participating[data-v-491483a6]{padding-top:10px}.add-more-btn[data-v-491483a6]{background:#303030;color:#fff;border-color:#303030}", ""]);
// Exports
module.exports = exports;
